import { render, staticRenderFns } from "./QuotationSummaryForm.vue?vue&type=template&id=65c9aa4a&lang=pug&"
import script from "./QuotationSummaryForm.vue?vue&type=script&lang=js&"
export * from "./QuotationSummaryForm.vue?vue&type=script&lang=js&"
import style0 from "./QuotationSummaryForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports